import React, { useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import PageHead from "../../components/Griya/PageHead";
import SalesSummaryBlog from "../../components/Griya/Analytics/SalesSummaryBlog";
//import RentStatisticTab from "../../components/Griya/Analytics/RentStatisticTab";
import { dashboardActions } from "../../../_store";
import OrderStatusApexChart from "./_OrderStatusApexChart";
import useFullPageLoader from "../../../hooks/useFullPageLoader";
import RentStatisticTab from "./_RentStatisticTab";

const OrderMgtDashboard = () => {
  const dispatch = useDispatch();
  const [loader, showLoader, hideLoader] = useFullPageLoader();

  // #region ------------------  Reducer --------------------------------

  const orderDashboardList = useSelector((x) => x.dashboard.orderDashboardList);
  const orderPrice = useSelector((x) => x.dashboard.OrderPrice);
  const isLoading = useSelector(x => x.dashboard.isLoading);

  // #endregion ------------------  Reducer End --------------------------------

  useEffect(() => {
    showLoader()
    dispatch(dashboardActions.getOrderDashboard());
    dispatch(dashboardActions.getOrderPrice());
  }, []);

  useEffect(() => {
    if (isLoading) {
      hideLoader();
    }

  }, [isLoading])

  return (
    <>
      <PageHead activePage="Dashboard" pageName="Order Dashboard" />
      <div className="row">
        <div className="col-xl-2 col-md-6">
          <div className="card bg-primary text-white">
            <div className="card-body">
              <div className="d-flex align-items-center">
                <div className="customer">
                  <h2 className="text-center font-w600 text-white">
                    {orderDashboardList.OrderCreatedCount}
                  </h2>
                  <p className="text-center font-w300">Order Created</p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="col-xl-2 col-md-6">
          <div className="card bg-gemar text-white">
            <div className="card-body">
              <div className="d-flex align-items-center">
                <div className="customer">
                  <h2 className="text-center font-w600 text-white">
                    {orderDashboardList.OrderAssignedCount}
                  </h2>
                  <p className="text-center font-w300">Order Assigned</p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="col-xl-2 col-md-6">
          <div className="card bg-warning text-white">
            <div className="card-body">
              <div className="d-flex align-items-center">
                <div className="customer">
                  <h2 className="text-center font-w600 text-white">
                    {orderDashboardList.OrderPreparedCount}
                  </h2>
                  <p className="text-center font-w300">Order Prepared</p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="col-xl-2 col-md-6">
          <div className="card bg-danger text-white">
            <div className="card-body">
              <div className="d-flex align-items-center">
                <div className="customer">
                  <h2 className="text-center font-w600 text-white">
                    {orderDashboardList.PaymentReceivedCount}
                  </h2>
                  <p className="text-center font-w300">Payment Received</p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="col-xl-2 col-md-6">
          <div className="card bg-gemar-org text-white">
            <div className="card-body">
              <div className="d-flex align-items-center">
                <div className="customer">
                  <h2 className="text-center font-w600  text-white">
                    {orderDashboardList.ReadyDispatchCount}
                  </h2>
                  <p className="text-center font-w300">Ready to Dispatch</p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="col-xl-2 col-md-6">
          <div className="card bg-green text-white">
            <div className="card-body">
              <div className="d-flex align-items-center">
                <div className="customer">
                  <h2 className="text-center font-w600 text-white">
                    {orderDashboardList.OrderDispatchedCount}
                  </h2>
                  <p className="text-center font-w300">Order Dispatched</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="row">
        <div className="col-xl-12">
          <div className="row">
            <div className="col-xl-6 col-xxl-6">
              {orderDashboardList && (
                <OrderStatusApexChart chartData={orderDashboardList} />
              )}
            </div>
            <div className="col-xl-6">
              {" "}
              <RentStatisticTab chartData={orderPrice} />{" "}
            </div>
          </div>
        </div>
      </div>
      {loader}
    </>
  );
};
export default OrderMgtDashboard;
